import { Prompt, withRouter } from 'react-router-dom';
import React from 'react';
import Button, { buttonColor, buttonType } from 'Components/Button';
import Modal from 'Components/Modal';

@withRouter
export default class TransitionBlockerModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isModalOpen: false,
    };

    this.transitionConfirmedByUser = false;
  }

  showUnsavedDataWarning = location => {
    this.modalConfirmAction = () => {
      this.setState({ isModalOpen: false }, () => {
        this.transitionConfirmedByUser = true;
        this.props.history.push(location);
      });
    };

    this.setState({ isModalOpen: true });
  };

  closeModal = () => {
    this.setState({ isModalOpen: false });
  };

  blockUnconfirmedTransition = location => {
    if (
      this.transitionConfirmedByUser ||
      this.props.transitionWhitelist.find(allowedTransitionNamePart =>
        location.pathname.includes(allowedTransitionNamePart)
      )
    ) {
      this.transitionConfirmedByUser = false;
      return true;
    }
    this.showUnsavedDataWarning(location);
    return false;
  };

  render() {
    return (
      <React.Fragment>
        {this.props.blockTransitions && <Prompt message={this.blockUnconfirmedTransition} />}
        <Modal isOpen={this.state.isModalOpen}>
          {this.props.children}
          <footer className='ect-modal-footer'>
            <Button
              label='No'
              type={buttonType.secondary}
              color={buttonColor.gray}
              buttonClassName='_height_40 _width_160'
              onClick={this.closeModal}
            />
            <Button label='Yes' buttonClassName='_height_40 _width_160' onClick={this.modalConfirmAction} />
          </footer>
        </Modal>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/Components/TransitionBlockerModal.jsx